export default __webpack_public_path__ + "static/media/photo--lg--group-close.abda6e0e.jpg";